export default "__VITE_ASSET__380e34c7__"